/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap.js';
import './compat-config.js';
import { createApp } from 'vue';
import store from './store';
import router from '@js/routes/app-routes.js';
import Axios, { axios } from '@js/utilities/axios.js';
import { EventBusPlugin } from '@js/utilities/event-bus.js';
import { BootstrapVueModalPlugin } from '@js/utilities/bootstrap-vue-modal.js';
import { BootstrapVueToastPlugin } from '@js/utilities/bootstrap-vue-toast.js';
import { preventBackdropDragClose } from '@js/utilities/prevent-backdrop-drag-close.js';
import { installAuthHelpers, installMomentHelper } from '@js/utilities/global-helpers.js';

import VueTour from 'vue-tour';
import { createBootstrap } from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import VueMultiselect from 'vue-multiselect';
import * as Sentry from '@sentry/vue';
import '@lottiefiles/lottie-player';
import App from './App.vue';
import 'vue-tour/dist/vue-tour.css';

axios.defaults.baseURL = import.meta.env.VUE_APP_API_BASE_URL;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const installVueTour = {
	install(app) {
		VueTour.install({
			component: app.component.bind(app),
			prototype: app.config.globalProperties,
		});
	},
};

const app = createApp({
	components: {
		App,
	},
});

// The #app template is compiled in the browser. Vue 2 kept its whitespace, so keep doing that.
app.config.compilerOptions.whitespace = 'preserve';

app.use(store);
app.use(router);
app.use(Axios);
app.use(EventBusPlugin);
app.use(createBootstrap());
app.use(installVueTour);
app.use(BootstrapVueModalPlugin);
app.use(BootstrapVueToastPlugin);
installMomentHelper(app);
installAuthHelpers(app, store);
preventBackdropDragClose();
app.component('multiselect', VueMultiselect);
app.mount('#app');

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_LARAVEL_DSN) {
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,
		release: import.meta.env.VITE_SENTRY_RELEASE,
		integrations: [
			Sentry.browserTracingIntegration({
				router,
			}),
		],
		tracePropagationTargets: [
			'absolutedomestics.com.au',
			'portal.absolutedomestics.com.au',
			'my.absolutedomestics.com.au',
			/^\//,
		],
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0,
	});
}
